import { QAlert } from "./QAlert";

export class QFileExistsAlert extends QAlert {
  constructor() {
    super();
  }

  ExecuteCustomCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = this.fWSMgr;
    var handled = true;
    switch (cmdCode) {
      case "DiscardAll":
        wsMgr.fUploadMgr.FinishUpload(false, this.fConflicts);
        break;
      default:
        handled = false;
        break;
    }
    return handled;
  }
}
